export default function(t,r){for(var n=t<0?"-":"",a=Math.abs(t).toString();a.length<r;)a="0"+a;return n+a}
